export function removeParamFromQueryString(url, paramToRemove) {
    const urlObj = new URL(url);
    const params = urlObj.searchParams;

    params.delete(paramToRemove);
    urlObj.search = params.toString();
    return urlObj.toString();
}

export function appendQueryParams(url, params) {
    if (!url) {
        return '';
    }
    if (Object.keys(params).length === 0) {
        return url;
    }
    const [urlWithoutHash, hash] = url.split('#');
    const [baseUrl, queryString] = urlWithoutHash.split('?');
    const searchParams = new URLSearchParams(queryString);

    for (const [key, value] of Object.entries(params)) {
        // append: 會添加新的參數而不移除舊的，可能導致重複值
        // set: 會替換現有參數的值，確保每個參數只有一個最新的值
        searchParams.set(key, value);
    }

    const newUrl = `${baseUrl}?${searchParams.toString()}`;
    return hash ? `${newUrl}#${hash}` : newUrl;
}
/**
 * 從 URL 取得指定的 querystring 參數值
 * @param {string} paramName - 要取得的參數名稱
 * @returns {string|null} 參數值，如果不存在則返回 null
 */
export const getUrlParam = (paramName) => {
    if (typeof window === 'undefined') return null;
    
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(paramName);
};
